import { Textarea } from "@/ui";
import { formatJson } from "./form";

/** 只读的多行块：字符串原样显示（消息原文、发给通道的内容），其他值按 JSON 缩进显示（路由 trace、审计的改动前后）。
 * 用只读多行框而不是行内 Code，多行内容才可读、可整段复制。 */
export function ReadonlyBlock({ value, label, rows }: { value: unknown; label: string; rows?: number }) {
  const text = typeof value === "string" ? value : formatJson(value);
  return <Textarea readOnly className="ax-mono" aria-label={label} rows={rows ?? Math.min(16, Math.max(3, text.split("\n").length))} value={text} />;
}
